import * as React from 'react';
import './WelcomeMessage.scss';

interface WelcomeMessageProps {
  onSendMessage: (message: string) => void;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ onSendMessage }) => (
  <div className="welcome-message">
    {/* Right side - Action buttons */}
    <div className="welcome-message__actions">
      <button 
        className="welcome-btn" 
        onClick={() => onSendMessage('Tell me what you can do')}
      >
        Tell me what you can do
      </button>
      <button 
        className="welcome-btn" 
        onClick={() => onSendMessage('Keep me updated on my favorite sports')}
      >
        Keep me updated on my favorite sports
      </button>
      <button 
        className="welcome-btn" 
        onClick={() => onSendMessage('Help me find something to watch')}
      >
        Help me find something to watch
      </button>
      <button 
        className="welcome-btn" 
        onClick={() => onSendMessage("What's my latest bill?")}
      >
        What's my latest bill?
      </button>
    </div>
  </div>
);

export { WelcomeMessage };
